import { PROGRAMS, IMAGES } from "./content";

const FALLBACK_IMAGE_BY_SLUG = PROGRAMS.reduce((acc, p) => ({ ...acc, [p.id]: p.image }), {});

// Parses DB values like "25+" or "3,500+" into a numeric value + suffix for <Counter>.
export const mapImpactStatRows = (rows) =>
  rows.map((row) => {
    const match = String(row.value).match(/^([\d,]+)(.*)$/);
    const numeric = match ? Number(match[1].replace(/,/g, "")) : 0;
    const suffix = match ? match[2] : "";
    return { value: numeric, suffix, label: row.label, sub: row.detail };
  });

// Maps DB program rows to the shape used across Home/Programs/About pages.
export const mapProgramRows = (rows) =>
  rows.map((row) => ({
    id: row.slug,
    name: row.name,
    tag: row.short_name,
    icon: row.icon,
    image: row.image_path || FALLBACK_IMAGE_BY_SLUG[row.slug] || IMAGES.volunteers,
    desc: row.description,
  }));
